import { ofType } from "redux-observable";
import { of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionNotificationLogin, TypeActionAuth } from "../../auth/actionAuth";
export var epicLoginNotificationServer = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAuth.Login), switchMap(function (action) {
        return deps
            .notificationNetSend({
            id: CommandCode.LoginNotificationServer,
            props: {
                authenticationToken: action.token,
                playerId: action.playerId,
            },
        })
            .pipe(retry(), switchMap(function () { return of(actionNotificationLogin()); }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/notifications/epics/epicLoginNotificationServer.ts
// module id = 2026
// module chunks = 3